import React, {
    PropsWithChildren,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react"
import { CSSTransition } from "react-transition-group"
import { PropsWithStyle } from "@rogue_4/types"
import classNames from "classnames"
import { noop } from "lodash"

import { CommonTransition } from "@/topic/rogue_4/components/CommonTransition"
import { getTransitionClassnames } from "../../utils/transition"
import GAME_EMITTER from "../Emitter"

import styles from "./index.module.less"

// 识别形如 "<colorValue>[contentValue]"的富文本
const processRichText = (text: string) => {
    const colorDict: Record<number, string> = {}
    let index_overflow = 0
    const result = text.matchAll(/<([^>]+)>\{([^}]+)\}/g)
    while (true) {
        const { value, done } = result.next()
        if (done) {
            break
        }
        const { index } = value
        const start = index - index_overflow
        for (let i = start; i < start + value[2].length; i++) {
            colorDict[i] = value[1]
        }
        index_overflow += 4 + value[1].length
    }
    return {
        text: text.replaceAll(
            /<([^>]+)>\{([^}]+)\}/g,
            (match) => match.match(/<([^>]+)>\{([^}]+)\}/)?.[2] ?? ""
        ),
        colorDict,
    }
}

export const richTextToHtml = (text: string) =>
    text.replaceAll(/<([^>]+)>\{([^}]+)\}/g, (match) => {
        const result = match.match(/<([^>]+)>\{([^}]+)\}/)
        return `<span style="color: ${result?.[1] ?? ""}">${result?.[2] ?? ""}</span>`
    })
const DialogFrame = React.forwardRef<
    HTMLDivElement,
    PropsWithStyle<{ active: boolean; bg: string }>
>(({ className, style, active, bg }, ref) => {
    return (
        <div
            ref={ref}
            className={classNames(
                styles.dialogFrame,
                active && styles.active,
                className
            )}
            style={style}
        >
            <div className={styles.contentContainer}>
                <div
                    className={styles.topImage}
                    style={{ backgroundImage: `url(${bg})` }}
                />
                <div className={styles.textContainer} />
            </div>
        </div>
    )
})
DialogFrame.displayName = "DialogFrame"

export const DialogTitle = React.forwardRef<
    HTMLDivElement,
    PropsWithStyle<{ active: boolean; noAnimation?: boolean; text: string }>
>(({ className, style, text, active, noAnimation }, ref) => {
    const [state, setState] = useState(false)
    useEffect(() => {
        setState(active)
    }, [active])
    // console.log(text)
    return (
        //需改回
        <CSSTransition
            in={state}
            timeout={{
                appear: noAnimation ? 0 : 800,
                enter: noAnimation ? 0 : 800,
                exit: noAnimation ? 0 : 500,
            }}
            // timeout={{
            //     appear: noAnimation ? 0 : 8,
            //     enter: noAnimation ? 0 : 8,
            //     exit: noAnimation ? 0 : 5,
            // }}
            classNames={getTransitionClassnames(styles)}
        >
            <div
                ref={ref}
                className={classNames(styles.dialogTitle, className)}
                style={style}
            >
                {/* <CommonTransition state={text === "" ? "1" : "2"}> */}
                {/* {text && ( */}
                <div className={styles.deco}></div>
                <CommonTransition state={text}>
                    <div>
                        <div className={styles.content}>
                            {text ? text : "..."}
                        </div>
                    </div>
                </CommonTransition>
                {/* )} */}
                {/* </CommonTransition> */}
            </div>
        </CSSTransition>
    )
})
DialogTitle.displayName = "DialogTitle"

export const DialogContent = React.forwardRef<
    HTMLDivElement,
    PropsWithStyle<{
        text: string
        onTypeEnd?: () => void
        delay?: number
    }>
    //需改回
>(({ className, style, text, delay = 75, onTypeEnd }, ref) => {
// >(({ className, style, text, delay = 5, onTypeEnd }, ref) => {
    const [indexState, setIndex] = useState(0)
    const [textR, setTextR] = useState("")
    const [colorDict, setColorDict] = useState<
        Record<number, string | undefined>
    >({})
    const cbRef = useRef<() => void>(noop)
    useEffect(() => {
        const { text: processedText, colorDict: newColorDict } =
            processRichText(text)
        setColorDict(newColorDict)
        setIndex(0)
        setTextR(processedText)
        let index = 0
        const cb = () => {
            if (index < processedText.length - 1) {
                index = processedText.length - 1
                GAME_EMITTER.off("NEXT", cb)
            }
        }
        GAME_EMITTER.on("NEXT", cb)
        const timer = setInterval(() => {
            if (index >= processedText.length) {
                window.clearInterval(timer)
                GAME_EMITTER.off("NEXT", cb)
                cbRef.current?.()
                return
            }
            setIndex(++index)
        }, delay)
        return () => {
            window.clearInterval(timer)
            GAME_EMITTER.off("NEXT", cb)
        }
    }, [text])
    useEffect(() => {
        cbRef.current = onTypeEnd ?? noop
    }, [onTypeEnd])
    const children = useMemo<React.ReactNode>(() => {
        const chars = textR.split("")
        let curLine = 0
        const spans: React.ReactNode[][] = [[]]
        chars.forEach((char, index) => {
            if (char === "\n") {
                curLine++
                spans.push([])
            } else {
                spans[curLine].push(
                    <span
                        key={`${index}-${char}`}
                        className={classNames(
                            styles.char,
                            index < indexState && styles.active
                        )}
                        style={{ color: colorDict[index] }}
                    >
                        {char}
                    </span>
                )
            }
        })
        return (
            <>
                {spans.map((arr, index) => (
                    <div key={index} className={styles.line}>
                        {arr}
                    </div>
                ))}
            </>
        )
    }, [indexState, textR])
    // const inRef = (ele: HTMLSpanElement) => {
    //     anime({
    //         targets: ele,
    //         opacity: 1,
    //         easing: "easeOutCubic",
    //         duration: delay,
    //     })
    // }
    return (
        <div
            ref={ref}
            className={classNames(styles.dialogContent, className)}
            style={style}
        >
            {children}
        </div>
    )
})
DialogContent.displayName = "DialogContent"

export default DialogFrame
